import React, { useState } from 'react';
import get from 'lodash/get';
import Page from 'app/components/misc/BasePage/Blog';
import BlogLayout from 'app/components/blog/BlogLayout';
import ArticleList from 'app/components/blog/ArticleList';
import {
  SearchSection,
  EmptySearchList,
  Head,
} from 'app/components/blog/search';
import useSearchArticles from 'entity/blog/hooks/useSearchArticles';
import BlogSubHeader from 'app/components/blog/BlogSubHeader';

const Search = ({ s }: { s: string }) => {
  // State
  const [searchTerm, setSearchTerm] = useState(s);

  const {
    result,
    isLoading,
    pagination,
    getSearchArticleByPage,
    debounceSearch,
  } = useSearchArticles(searchTerm);

  // Selectors
  return (
    <Page renderSubHeader={() => <BlogSubHeader />}>
      <Head search={debounceSearch} />
      <BlogLayout>
        <SearchSection
          searchTerm={searchTerm}
          resultTerm={debounceSearch}
          resultCount={pagination.total}
          onChange={setSearchTerm}
          loading={isLoading}
        />
        <ArticleList
          articles={result}
          loading={isLoading}
          currentPage={pagination.page}
          totalPage={pagination.totalPages}
          onPageChange={({ selected }) => {
            getSearchArticleByPage(selected + 1);
          }}
          renderEmptyList={() => <EmptySearchList />}
        />
      </BlogLayout>
    </Page>
  );
};

Search.getInitialProps = async ({ query }) => {
  const s = get(query, 's', '');
  return {
    s,
  };
};

export default Search;
